import { KeenSliderInstance } from "keen-slider";

export function getSliderMaxIdx(slider: KeenSliderInstance): number {
    if (!slider.options.loop) {
        return slider.track.details.maxIdx;
    }

    return slider.track.details.slides.length - 1;
}
